import axios from 'axios';


const operation = (data) => axios.get('/safe/working/list', data);    //安全运行
const risk = (data) => axios.get('/safe/risk/list', data);//风险指数
const behavior = (data) => axios.get('/safe/monitor/list', data);//行为监控
const firecontrol = (data) => axios.get('/safe/fighting/group', data);//消防设备

const ailist = (data) => axios.get('/safe/ai/list2', data);//ai安全
const security = (data) => axios.get('/safe/video/list2', data);//安防视频
const area = (data) => axios.get('/safe/area/list', data);//安全区域
const reminder = (data) => axios.get('/safe/alarm/list', data);//风险提示
const plan = (data) => axios.get('/safe/alarm/planList', data);//异常预案
const timestatus = (data) => axios.get('/safe/conf/list', data);



export default {
  operation,
  risk,
  behavior,
  firecontrol,
  ailist,
  security,
  area,
  reminder,
  plan,
  timestatus,
}
